import React from 'react';
import ReactDom from 'react-dom';
import $ from 'jquery';
import Language from '../services/Language.js';
import utils from '../services/utils.js';
import AppModalWidget from './AppModalWidget.js';
import SelectSearch from 'react-select-search';
import {ACTIONS} from "../site/component/CryptoVerification/CryptoVerification";
import CryptoModalVerificationsSucces from "./CryptoModalVerificationsSucces";

let inst;

class CryptoModalVerifications extends React.Component {
    constructor(props) {
        super(props);
        if (!inst) {
            this.url = '';
            this.sendedData = {};
            this.modalObject = null;
            this.currency = null;
            this.settings = {};
            this.currenciesForPaid = [];
            this.cryptoModalVerificationsForm = null;
            this.approximateCostEl = null;
            this.approximateCost = null;

            inst = this;
        }

        this._onChangeCurrency = this._onChangeCurrency.bind(this);

        return inst;
    }

    renderNetwork(props, { stack, name, linkToIcon }, snapshot, className) {
        let classNoUrl = 'select-search__option__img--url-false';
        if (linkToIcon) {
            classNoUrl = '';
        }

        return (
            <button {...props} className={className} type="button">
                <span
                    className={`${className} select-search__option__img ${classNoUrl}`}
                    style={{ backgroundImage: "url(" + linkToIcon + ")" }} />
                <span>{name}</span>
            </button>
        );
    }

    renderNetworkValue(valueProps, snapshot, className) {
        const { option, value } = snapshot;
        const style = {
            fontFamily: (!snapshot.focus && option && 'stack' in option) ? option.stack : null,
        };

        const inputVal = snapshot.displayValue;
        const linkToIcon = (typeof value === 'object' && value !== null && value.hasOwnProperty('linkToIcon')) ? value.linkToIcon : '';

        let classNoUrl = 'select-search__option__img--url-false';
        if (linkToIcon) {
            classNoUrl = '';
        }

        return (
            <span className={ "select-search__value-custom" }>
                 <span
                     className={`${className} select-search__option__img ${classNoUrl}`}
                     style={{ backgroundImage: "url(" + linkToIcon + ")" }} />
                 <input {...valueProps} className={className} style={style} value={inputVal} />
            </span>
        );
    }

    _onChangeCurrency(currency) {
        this.currency = currency;

        this.calculateApproximateCost(this.currency, this.updateApproximateCost);
    }

    callback() { }

    showModal(url, sendedData, currenciesForPaid, cryptoAddressVerification, callback) {
        if (typeof callback === 'function') {
            this.callback = callback;
        }

        this.sendedData = sendedData;
        this.currenciesForPaid = currenciesForPaid;
        this.url = url;
        this.currency = currenciesForPaid.length ? currenciesForPaid[0].value : ''

        const modalSettings = {
            closeOnBgClick: true,
            wrapContentClass: "crypto-modal-verifications"
        };

        this.modalObject = $("<div />", {
            "class": "crypto-modal-verifications__body"
        });

        this.modalObject.html(
            `<button class="crypto-modal-verifications__button-close modal-close jsCloseModal" type="button">
                <svg width="24" height="24" class="icon icon--close" viewBox="0 0 24 24"xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" />
                </svg>
            </button>
            <form id="cryptoModalVerificationsForm" action="#" class="crypto-modal-verifications__form">
                <div class="crypto-modal-verifications__top">
                    <h2 class="crypto-modal-verifications__title">` + Language.getLabel('L_CRYPTO_MODAL_VERIFICATIONS_TITLE') + `</h2>
                </div>

                <div class="crypto-modal-verifications__info">
                    <div class="crypto-modal-verifications__info-left">
                        <p class="crypto-modal-verifications__info-text">` + Language.getLabel('L_CRYPTO_MODAL_VERIFICATIONS_INFO') + `:</p>
                    </div>

                    <div class="crypto-modal-verifications__info-right">
                        <span class="crypto-modal-verifications__total">${cryptoAddressVerification.cost} ${utils.getDisplayOrRealName(cryptoAddressVerification.currencyPayment)}</span>
                    </div>
                </div>

                ` + (this.currenciesForPaid.length > 0 ?
                    `<div class="crypto-modal-verifications__select">
                        <div class="crypto-modal-verifications__select-label">
                             `+ Language.getLabel('L_CRYPTO_MODAL_VERIFICATIONS_LABEL') +`
                        </div>
                        <div class="crypto-modal-verifications__select-wrapper"></div>
                        <div class="crypto-modal-verifications__select-noti">
                            ` + Language.getLabel('L_CRYPTO_MODAL_VERIFICATIONS_NOTI') + `:
                            <span class="crypto-modal-verifications__select-noti-total" id="approximateСost"/>
                        </div>
                    </div>` : `<p class="crypto-modal-verifications__attention">
                        ` + Language.getLabel('L_EXCEPTION_NO_CURRENCIES_AVAILABLE_FOR_PAYMENT') + `
                        </p>`) + `

                <div class="crypto-modal-verifications__bottom">
                    <button class="button button--green modal-approve crypto-modal-verifications__button `+(this.currenciesForPaid.length === 0 ? 'disabled' : '')+`" type="submit"
                        id="crypto-modal-verifications__button_id">` + Language.getLabel('L_CRYPTO_MODAL_VERIFICATIONS_BTN') + `</button>
                </div>
            </form>`
        );

        this.cryptoModalVerificationsForm = this.modalObject.find("#cryptoModalVerificationsForm");
        this.approximateCostEl = this.modalObject.find("#approximateСost");

        if (this.currency) {
            this.calculateApproximateCost(this.currency, this.updateApproximateCost);
        }

        const handleSubmit = (e) => {
            e && e.preventDefault();

            if (this.currenciesForPaid.length > 0) {
                this.sendedData['currencyShortNameToPayment'] = this.currency;
                this.sendRequest(this.url, this.sendedData);
            }
        }

        this.cryptoModalVerificationsForm.submit(handleSubmit);

        modalSettings.el = this.modalObject;
        modalSettings.destroyClose = true;

        modalSettings.afterShow = () => {
            this.afterShowHandler();
        };

        AppModalWidget.show(modalSettings);
    }

    afterShowHandler() {
        const container = $(".crypto-modal-verifications__select-wrapper").get(0);

        if (container) {
            ReactDom.render(
                <SelectSearch
                    options={this.currenciesForPaid}
                    onChange={this._onChangeCurrency}
                    search
                    renderOption={this.renderNetwork}
                    renderValue={this.renderNetworkValue}
                    value={this.currenciesForPaid.length ? this.currenciesForPaid[0].name : ''}
                />,
                container
            )
        }
    }

    sendRequest(url, sendedData) {
        const that = this;
        $('#crypto-modal-verifications__button_id')[0].disabled = true;
        that.callback(ACTIONS.BEGINED_VERIFICATION_PROCESS, {});
        utils.app_post(url, sendedData).then((resp) => {
            if (resp.type === 'success') {
                that.callback(ACTIONS.SHOW_RESULT, resp.data.cryptoAddressVerification)
                return;
            }
            if (resp.type === 'error') {
                this.callback(null, {});
                return;
            }
        });
    }

    calculateApproximateCost(currency, cb) {
        this.cryptoModalVerificationsForm.block();
        utils.app_post(utils.getLocalizeUrl('/api/crypto-address/calculate-approximate-cost'), { currency: currency }).then((resp) => {
            this.cryptoModalVerificationsForm.unblock();
            if (resp.type === 'success') {
                cb(resp.data.approximateCost, this.currenciesForPaid.find(item => item.value == currency).name, this.approximateCostEl);
            }
        });
    }

    updateApproximateCost(approximateCost, currency, approximateCostEl) {
        approximateCostEl.html('≈ ' + approximateCost + ' ' + currency);
    }

    recentAnimation() { }

    close(cb) {
        if (this.modalObject) {
            AppModalWidget.close(cb);
        }
    }
}

export default new CryptoModalVerifications();
